<template>
  <div class="page">
    <div class="list-body">
      <form @submit.prevent="submit" class="row">
        <div class="col-md-12 d-flex flex-column gap-2">
          <div class="form-floating">
            <input type="text" :disabled="disableFields" v-model="refrence" class="form-control" id="balance" placeholder="Password " required>
            <label for="balance">Reference</label>
          </div>

          <div class="form-floating">
            <input type="text" :disabled="disableFields" v-model="amount" class="form-control" id="amount" placeholder="Amount" required>
            <label for="amount">Amount</label>
          </div>
          <div >
            <label for="branch">Select Branch</label>
            <v-select
                id="branch"
                v-model="branch"
                label="branchName"
                :reduce="item => item.branchName"
                :disabled="disableFields"
                :options="branches"
            ></v-select>
          </div>
        </div>
        <div class="container mt-4" v-if="!disableFields">
          <button type="submit" class="btn btn-primary w-100" >
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            SAVE
          </button>
        </div>
      </form>
      <div class="container mt-4" v-if="this.url && disableFields">
        <button  @click="copyToClipboard" class="btn btn-primary w-100" >
          Copy to Clipboard
        </button>
      </div>

      <div class="container mt-2" v-if="this.url && disableFields">
        <button  @click="reset" class="btn btn-primary w-100" >
          Make New Transaction
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import clipboardCopy from 'clipboard-copy';
export default {
  beforeMount() {
    this.getBraches();
  },
  computed:{
    userData(){
      return this.$store.getters.getuserData;
    },
    api(){
      return this.$store.getters.getApi;
    },
    url(){
      return this.$store.getters.getURl;
    }
  },
  data() {
    return {
      amount: '',
      branch: '',
      refrence: '',
      loading: false,
      branches: [],
      disableFields : false
    }
  },
  methods:{
    reset(){
      this.$store.commit('reset');
      this.formReset();
      return this.disableFields = false;
    },
    getBraches(){
      return this.$store.dispatch('getBranches')
          .then((response) => {
            this.branches = response;
          })
    },
    copyToClipboard() {
      clipboardCopy(this.url)
          .then(() => {
            responses.showSuccess('Copied to clipboard');
          })
    },
    submit(){
      const payload = {
        API_KEY: this.api,
        amount: this.amount,
        Service_Description: `Branch : `+this.branch,
        Client_Refrence: this.refrence,
        Cancel_Url: 'https://zero.chrilantech.com/test-failed',
        Sucess_Url: 'https://zero.chrilantech.com/test-success',
      }
      this.loading = true;
      return this.$store.dispatch('createTransaction', payload)
          .then(() => {
            clipboardCopy(this.url)
            responses.showSuccess('Successfully submitted and url copied to clipboard')
            this.disableFields = true;
          }).finally(()=> this.loading = false)
    },
    formReset(){
          this.amount = '',
          this.branch = '',
          this.refrence= ''
    }
  }
}
</script>

<style scoped>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.page {
  height: 100%;
  width: 100%;
  background: transparent;
  overflow-x: hidden;
  position: relative;
}

.list-body {
  padding: 10px;
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

.col-md-4 {
  margin: 5px 0 0;
}
</style>
